import PublicReportData from './ReportData/PublicReportData';
import { TabPanel, Tabs } from '@round/ui-kit';
import usePlatformHashSelect, { getDefaultPlatform } from 'Modules/Plans/hooks/usePlatformHashSelect';
import PlatformTabs from 'Modules/Plans/components/PlatformTabs/PlatformTabs';
import styles from './PublicReport.module.css';
import PlatformHeadlineStats from './PlatformHeadlineStats/PlatformHeadlineStats';
import PublicReportInstagramCampaigns from './Campaigns/InstagramCampaign/PublicReportInstagramCampaigns';
import PublicReportYoutubeCampaigns from './Campaigns/YoutubeCampaign/PublicReportYoutubeCampaigns';
import ReportNotFound from './ReportNotFound/ReportNotFound';
import capitalize from 'lodash/capitalize';
import { Helmet } from 'react-helmet';
import usePublicReportId from './usePublicReportId';
import TikTokTab from './Tabs/TikTokTab/TikTokTab';
import { usePublicReport } from '@round/creatorbase-helpers/api-hooks';

const PublicReport = () => {
    const uuid = usePublicReportId();

    const { data: report, getErrorStatusCode } = usePublicReport(uuid);
    const isNotFound = getErrorStatusCode() === 404;

    const [activeTab, setActiveTab] = usePlatformHashSelect((goToPlatform) => {
        if (!report) {
            return;
        }

        goToPlatform(getDefaultPlatform(report.platforms), true);
    });

    if (isNotFound) {
        return <ReportNotFound />;
    }

    const helmetTitle = report?.name
        ? `${report.name} · Shared Report ${activeTab ? ` · ${capitalize(activeTab)}` : ''}`
        : null;

    return (
        <Tabs activeTab={activeTab} onChange={setActiveTab}>
            <Helmet>{helmetTitle && <title>{helmetTitle}</title>}</Helmet>
            <header className={styles.header}>
                <PublicReportData />
                <PlatformTabs className={styles.tabsNav}>
                    <PlatformTabs.Tab name="instagram" platform="instagram" />
                    <PlatformTabs.Tab name="tiktok" platform="tiktok" />
                    <PlatformTabs.Tab name="youtube" platform="youtube" />
                </PlatformTabs>
            </header>

            <main>
                <TabPanel name="instagram">
                    <PlatformHeadlineStats publicReportId={uuid} platform="instagram" />
                    <section className={styles.campaigns}>
                        <PublicReportInstagramCampaigns publicReportId={uuid} />
                    </section>
                </TabPanel>

                <TabPanel name="tiktok">
                    <PlatformHeadlineStats publicReportId={uuid} platform="tiktok" />
                    <section className={styles.campaigns}>
                        <TikTokTab publicReportId={uuid} />
                    </section>
                </TabPanel>

                <TabPanel name="youtube">
                    <PlatformHeadlineStats publicReportId={uuid} platform="youtube" />
                    <section className={styles.campaigns}>
                        <PublicReportYoutubeCampaigns publicReportId={uuid} />
                    </section>
                </TabPanel>
            </main>
        </Tabs>
    );
};

export default PublicReport;
